import { createAction, props } from "@ngrx/store";

export const setActiveLanguage = createAction('[Application] Set Active Language', props<{ activeLanguage: string }>());
